export enum SoftphoneConnectionBehaviorEnum {
  AutoConnect = 'AutoConnect',
  OptIn = 'OptIn',
  DoNotConnect = 'DoNotConnect',
}
